import type { HTMLAttributes } from "react";
import { cn } from "../helpers/class-names";

type CardProps = HTMLAttributes<HTMLElement> & { as?: "div" | "section" };

export function Card({ as: Element = "div", className, ...props }: CardProps) {
  return <Element className={cn("ui-card", className)} {...props} />;
}
